const UserActionTypes = {
    ADD_USER_DETAILS_ACTION : "ADD_USER_DETAILS_ACTION",
    ADD_USER_ORDERS_ACTION : "ADD_USER_ORDERS_ACTION",
    RESET_USER_ACTION: "RESET_USER_ACTION",
    ADD_REFERRAL_ACTION: "ADD_REFERRAL_ACTION"
  };
  
  export default UserActionTypes;